import { Avatar, Container } from "@mui/material";
import React from "react";
import classes from "./Testimonial.module.css";
import sunil from "../utils/images/sunil.jpeg";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
const Testimonial = () => {
  return (
    <Container sx={{ marginTop: "5em" }}>
      <div className={classes.topic}>
        <h1>
          <span className={classes.journey}>Test</span>

          <span className={classes.analytics}>imonial</span>
        </h1>
      </div>
      <div className={classes.testimonials}>
        <div className={classes.testimonialCard}>
          <div className={classes.testprofile}>
            <img src={sunil} />
            <div>
              <h5>
                Sunil Kumar{" "}
                <span className={classes.testDesignation}>
                  CEO OF GREENESTEP
                </span>
              </h5>
            </div>
          </div>

          <div className={classes.comment}>
            <FormatQuoteIcon sx={{ color: "black" }} />
            <p>
              We were struggling to get a unified view of customer usage of our
              ERP platform. Journey Analytics enabled us with insights to get
              360 degree view of our platform usage. This enabled our platform
              investment decisions. Journey Analytics gave us better customer
              engagement using the feature usage, reduction in churn rate as we
              proactively serviced, and in turn increased renewals and
              subscription rates.
              <FormatQuoteIcon sx={{ color: "black" }} />
            </p>
          </div>
        </div>
        <div className={classes.testimonialCard}>
          <div className={classes.testprofile}>
            <img src="https://cdn-icons-png.flaticon.com/512/6386/6386976.png" />
            <div>
              <h5>
                David Finger{" "}
                <span className={classes.testDesignation}>
                  CO-FOUNDER OF LEADFACTIA
                </span>
              </h5>
            </div>
          </div>

          <div className={classes.comment}>
            <FormatQuoteIcon sx={{ color: "black" }} />
            <p>
              I spent hours every week combining data from multiple sources to
              get the insights I needed. Journey Analytics not only took this
              burden off my hands, but found some marketing insights I had
              missed. Now I have a single view of my marketing data without
              having to spend hours creating custom reports.
              <FormatQuoteIcon sx={{ color: "black" }} />
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default Testimonial;
